import { render, staticRenderFns } from "./announcement-entry.vue?vue&type=template&id=4a15b561"
import script from "./announcement-entry.vue?vue&type=script&lang=js"
export * from "./announcement-entry.vue?vue&type=script&lang=js"
import style0 from "./announcement-entry.vue?vue&type=style&index=0&id=4a15b561&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports